import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { heroInformationCircleMini } from '@ng-icons/heroicons/mini';
import { ModalComponent } from '../modal/modal.component';
import { TermsSignService } from '../../service';

@Component({
  selector: 'common-terms-sign-modal',
  standalone: true,
  imports: [CommonModule, ModalComponent, TranslateModule, NgIconComponent],
  providers: [
    provideIcons({
      heroInformationCircleMini,
    }),
  ],
  templateUrl: './terms-sign-modal.component.html',
  styleUrls: ['./terms-sign-modal.component.css'],
})
export class TermsSignModalComponent {
  @Input()
  public isOpen = false;

  @Output()
  public isOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private readonly termsSignService: TermsSignService) {
    this.subscribeToSigningInProgress();
  }

  public subscribeToSigningInProgress(): void {
    this.termsSignService
      .getSigningInProgressObservable()
      .subscribe(signingInProgress => {
        this.isOpen = signingInProgress;
      });
  }

  public getTermsSignMessage(): string | undefined {
    return this.termsSignService.getCurrentTermsSignMessage();
  }

  public onCloseClick(): void {
    this.close();
  }

  private close(): void {
    this.isOpen = false;
    this.isOpenChange.emit(false);
  }
}
